(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["resources"] && !Shopify.designMode) return;
  try {
    const dupontInitializers = [];
const dupontCleanup = new Map();
const dupontOwn = (element, cleanup) => {
 const previous = dupontCleanup.get(element);
 dupontCleanup.set(element, () => { previous?.(); cleanup(); });
};
const dupontReady = callback => {
 dupontInitializers.push(callback);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, {once:true});
 else callback();
};
document.addEventListener('shopify:section:load', () => dupontInitializers.forEach(callback => callback()));
document.addEventListener('shopify:section:unload', event => {
 for (const [element, cleanup] of dupontCleanup) if (element === event.target || event.target.contains(element)) { cleanup(); dupontCleanup.delete(element); }
});

document.documentElement.classList.add('js');
dupontReady( () => {
  const skip = document.querySelector('.skip-link');
  if (skip && !skip.dataset.bound) { skip.dataset.bound = 'true'; skip.addEventListener('click', event => {
    const main = document.querySelector('main');
    if (!main) return;
    event.preventDefault(); main.tabIndex = -1; main.focus(); main.scrollIntoView({behavior:'instant'});
  }); }
  document.querySelectorAll('.site-header').forEach(header => {
    if (header.dataset.bound) return; header.dataset.bound = 'true';
    const controller = new AbortController(); dupontOwn(header, () => controller.abort());
    const listen = (target, event, callback) => target.addEventListener(event, callback, {signal:controller.signal});
    const button = header.querySelector('.menu-button'), navigation = header.querySelector('nav');
    const desktop = matchMedia('(min-width:1101px)');
    button.setAttribute('aria-controls',navigation.id); button.setAttribute('aria-expanded','false');
    const items = [...header.querySelectorAll('.nav-item--dropdown')];
    const setSubmenu = (item,open) => { item.classList.toggle('submenu-open',open); item.querySelector('button').setAttribute('aria-expanded',String(open)); };
    const closeSubmenus = () => items.forEach(item => setSubmenu(item,false));
    const close = () => { header.classList.remove('nav-open'); button.setAttribute('aria-expanded','false'); button.setAttribute('aria-label','Menu'); button.textContent='Menu'; closeSubmenus(); };
    items.forEach((item,index) => {
      const toggle = item.querySelector('button'), submenu = item.querySelector('.nav-submenu');
      submenu.id = `category-menu-${index}`; toggle.setAttribute('aria-controls',submenu.id);
      listen(toggle, 'click',() => { const open=!item.classList.contains('submenu-open'); closeSubmenus(); setSubmenu(item,open); });
      listen(item, 'pointerenter',event => { if(desktop.matches && event.pointerType==='mouse') { closeSubmenus(); setSubmenu(item,true); } });
      listen(item, 'pointerleave',() => { if(!item.contains(document.activeElement)) setSubmenu(item,false); });
      listen(item, 'focusout',event => { if(!item.contains(event.relatedTarget)) setSubmenu(item,false); });
    });
    listen(button, 'click',() => { const open=!header.classList.contains('nav-open'); header.classList.toggle('nav-open',open); button.setAttribute('aria-expanded',String(open)); button.textContent=open?'Close':'Menu'; button.setAttribute('aria-label',open?'Close menu':'Menu'); });
    listen(navigation, 'click',event => { if(event.target.closest('a')) close(); });
    listen(document, 'keydown',event => {
      if(event.key!=='Escape') return;
      const item=items.find(item=>item.classList.contains('submenu-open'));
      if(item) { closeSubmenus(); item.querySelector('button').focus(); }
      else if(header.classList.contains('nav-open')) { close(); button.focus(); }
    });
    listen(document, 'click',event => { if(!header.contains(event.target)) closeSubmenus(); });
    listen(desktop, 'change',close);
  });
});


(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 1101px) and (hover: hover) and (pointer: fine)');
  const touch = matchMedia('(any-pointer: coarse)');
  let paused = false;
  try { paused = sessionStorage.getItem('dupont-motion-paused') === 'true'; } catch {}
  const listeners = new Set();
  const permitted = () => desktop.matches && !touch.matches && !reduced.matches && !window.Shopify?.designMode && Boolean(document.querySelector('[data-motion-toggle]'));
  const emit = () => {
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.hidden = !permitted();
      button.textContent = paused ? button.dataset.resume : button.dataset.pause;
    });
    listeners.forEach(callback => callback());
  };
  const setPaused = value => {
    paused = value;
    try { sessionStorage.setItem('dupont-motion-paused', String(value)); } catch {}
    emit();
  };
  window.homepageMotion = {
    canPlay: () => permitted() && !paused && document.visibilityState === 'visible',
    permitted, pause: () => setPaused(true),
    subscribe(callback) { listeners.add(callback); return () => listeners.delete(callback); }
  };
  dupontReady( () => {
    document.querySelectorAll('[data-motion-toggle]').forEach(button => { if (button.dataset.bound) return; button.dataset.bound = 'true'; button.addEventListener('click', () => setPaused(!paused)); });
    emit();
  });
  [reduced, desktop, touch].forEach(query => query.addEventListener('change', emit));
  document.addEventListener('visibilitychange', emit);
})();

dupontReady( () => {
  document.querySelectorAll('[data-hero-slideshow]').forEach(gallery => {
    if (gallery.dataset.bound) return; gallery.dataset.bound = 'true';
    const slides = [...gallery.querySelectorAll('[data-hero-slide]')];
    const motion = window.homepageMotion;
    if (!motion || slides.length < 2) return;
    let index = 0, timer = 0, hovered = false, visible = false;
    const show = next => {
      index = next;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', String(i !== index));
      });
    };
    const sync = () => {
      clearTimeout(timer);
      if (motion.permitted()) gallery.querySelectorAll('template[data-hero-template]').forEach(template => { template.replaceWith(template.content.cloneNode(true)); });
      if (!motion.permitted()) show(0);
      if (!motion.canPlay() || hovered || !visible) return;
      timer = setTimeout(() => { show((index + 1) % slides.length); sync(); }, Number(gallery.dataset.heroInterval) || 5200);
    };
    gallery.addEventListener('pointerenter', () => { hovered = true; sync(); });
    gallery.addEventListener('pointerleave', () => { hovered = false; sync(); });
    gallery.addEventListener('focusin', () => motion.pause());
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }); observer.observe(gallery);
    const unsubscribe = motion.subscribe(sync); dupontOwn(gallery, () => { clearTimeout(timer); observer.disconnect(); unsubscribe(); });
    sync();
  });
});

dupontReady( () => {
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    if (carousel.dataset.bound) return; carousel.dataset.bound = 'true';
    const track = carousel.querySelector('.product-rail');
    const previous = carousel.querySelector('[data-carousel-previous]');
    const next = carousel.querySelector('[data-carousel-next]');
    const announcement = carousel.querySelector('[data-carousel-announcement]');
    const cards = [...track.querySelectorAll('.product-card')];
    const motion = window.homepageMotion;
    if (!motion || cards.length < 2) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let clones = [], frame = 0, last = 0, position = track.scrollLeft, hovered = false, visible = false;
    let announceTimer = 0;
    const step = () => cards[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const setWidth = () => step() * cards.length;
    const stop = () => { cancelAnimationFrame(frame); frame = 0; position = track.scrollLeft; carousel.classList.remove('carousel-playing'); };
    const canPlay = () => motion.canPlay() && !hovered && visible;
    const tick = time => {
      if (!canPlay()) return stop();
      position = (position + 24 * Math.min(50, time-last)/1000) % setWidth();
      track.scrollLeft = position; last = time; frame = requestAnimationFrame(tick);
    };
    const sync = () => {
      if (!motion.permitted() && clones.length) {
        stop(); const originalPosition = track.scrollLeft % setWidth();
        clones.forEach(clone => clone.remove()); clones = []; track.scrollLeft = originalPosition;
      }
      if (!canPlay()) return stop();
      if (!clones.length) {
        clones = cards.map(card => {
          const clone = card.cloneNode(true);
          clone.dataset.carouselClone = 'true'; clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          clone.querySelectorAll('a,button,[tabindex]').forEach(el => el.tabIndex = -1);
          clone.querySelectorAll('img').forEach(img => img.alt = '');
          track.append(clone); return clone;
        });
      }
      if (!frame) { position = track.scrollLeft; last = performance.now(); carousel.classList.add('carousel-playing'); frame = requestAnimationFrame(tick); }
    };
    const announce = () => {
      const index = Math.round(track.scrollLeft / step()) % cards.length;
      announcement.textContent = `${cards[index].querySelector('h3').textContent.trim()}, item ${index+1} of ${cards.length}`;
    };
    const move = direction => {
      motion.pause();
      const max = clones.length ? setWidth() : track.scrollWidth-track.clientWidth;
      let target = (direction > 0 ? Math.floor(track.scrollLeft/step())+1 : Math.ceil(track.scrollLeft/step())-1)*step();
      if (direction > 0 && track.scrollLeft >= max-2) target = 0;
      else if (target < 0) target = clones.length ? setWidth()-step() : max;
      track.scrollTo({left:Math.min(target,max), behavior:reduced.matches?'auto':'smooth'});
    };
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    carousel.addEventListener('focusin', event => {
      motion.pause();
      const card = event.target.closest('.product-card:not([data-carousel-clone])');
      card?.scrollIntoView({behavior:'instant',block:'nearest',inline:'nearest'});
    });
    track.addEventListener('pointerenter', () => { hovered = true; sync(); });
    track.addEventListener('pointerleave', () => { hovered = false; sync(); });
    track.addEventListener('pointerdown', () => motion.pause());
    track.addEventListener('wheel', () => motion.pause(), {passive:true});
    track.addEventListener('keydown', () => motion.pause());
    track.addEventListener('scroll', () => {
      if (frame) return;
      position = track.scrollLeft; clearTimeout(announceTimer); announceTimer = setTimeout(announce,150);
    }, {passive:true});
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }); observer.observe(track);
    const unsubscribe = motion.subscribe(sync); window.addEventListener('resize',sync);
    dupontOwn(carousel, () => { stop(); clearTimeout(announceTimer); observer.disconnect(); unsubscribe(); window.removeEventListener('resize',sync); });
    carousel.classList.add('carousel-ready'); sync();
  });
});

dupontReady(() => {
 let pending;
 try { pending = JSON.parse(sessionStorage.getItem('dupont-variant-focus')); sessionStorage.removeItem('dupont-variant-focus'); } catch {}
 if (!pending || pending.path !== location.pathname || Date.now() - pending.time > 60000) return;
 const selector = document.querySelector('[data-variant-selector]');
 if (selector && selector.value === pending.variant) {
  const restore = () => requestAnimationFrame(() => {
   const controls = selector.closest('.purchase-controls');
   if (![document.body, controls, selector].includes(document.activeElement)) return;
   selector.focus({preventScroll:true}); controls.scrollIntoView({behavior:'instant',block:'start'});
  });
  if (document.readyState === 'complete') restore(); else window.addEventListener('pageshow',restore,{once:true});
 }
});

dupontReady(() => {
 const enhance = () => {
  const button = document.getElementById('effectiveAppsScrollToTopBtn');
  if (!button || button.dataset.keyboardBound) return;
  button.dataset.keyboardBound = 'true'; button.setAttribute('tabindex','0');
  button.addEventListener('keydown',event => {
   if (event.key !== 'Enter' && event.key !== ' ') return;
   event.preventDefault(); button.dispatchEvent(new MouseEvent('click',{bubbles:true}));
  });
 };
 if (!document.body.dataset.scrollTopObserved) {
  document.body.dataset.scrollTopObserved = 'true';
  const observer = new MutationObserver(enhance); observer.observe(document.body,{childList:true,subtree:true});
 }
 enhance();
});

dupontReady( () => { const topic = document.querySelector('#ContactTopic'); const value = new URLSearchParams(location.search).get('inquiry'); if (topic && [...topic.options].some(option => option.value === value)) topic.value = value; });
document.addEventListener('change', event => {
 if (event.target.matches('[data-variant-selector]')) {
  const selector = event.target;
  try { sessionStorage.setItem('dupont-variant-focus', JSON.stringify({path:location.pathname, variant:selector.value, time:Date.now()})); } catch {}
  const region = selector.closest('[data-product-section]'); region?.setAttribute('aria-busy','true');
  const status = selector.form.querySelector('[data-variant-status]'); if (status) status.textContent = status.dataset.loading;
  selector.form.requestSubmit();
 }
});

dupontReady( () => {
 const input = document.querySelector('[data-predictive-input]');
 if (!input || input.dataset.bound) return; input.dataset.bound = 'true';
 const panel = document.getElementById('SearchSuggestions');
 const status = document.querySelector('[data-predictive-status]');
 let timer, controller, revision = 0;
 const clear = () => { clearTimeout(timer); controller?.abort(); revision++; panel.hidden = true; panel.replaceChildren(); status.textContent = ''; };
 input.addEventListener('input', () => {
  clear(); const query = input.value.trim(); if (query.length < 2) return;
  const current = revision;
  timer = setTimeout(async () => {
   controller = new AbortController();
   try {
    const url = new URL(input.dataset.endpoint, location.origin);
    url.search = new URLSearchParams({q: query, 'resources[type]': 'product', 'resources[limit]': '6', section_id: 'predictive-search'}).toString();
    const response = await fetch(url, {signal: controller.signal});
    if (!response.ok) return;
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = doc.querySelector('[data-predictive-results]');
    if (current !== revision || !content) return;
    panel.replaceChildren(content); panel.hidden = false; status.textContent = status.dataset.loaded;
   } catch (error) { if (error.name !== 'AbortError') clear(); }
  }, 250);
 });
 const escape = event => { if (event.key === 'Escape' && !panel.hidden) { clear(); input.focus(); } };
 document.addEventListener('keydown', escape); dupontOwn(input, () => { clear(); document.removeEventListener('keydown',escape); });
});

dupontReady(() => {
 document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  if (gallery.dataset.bound) return; gallery.dataset.bound = 'true';
  const track = gallery.querySelector('[data-gallery-stage]'); if (!track) return;
  const panels = [...track.querySelectorAll('[data-gallery-panel]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
  const toolbar = gallery.querySelector('[data-gallery-controls]');
  const count = gallery.querySelector('[data-gallery-count]');
  const previous = gallery.querySelector('[data-gallery-previous]');
  const next = gallery.querySelector('[data-gallery-next]');
  const zoom = gallery.querySelector('[data-gallery-zoom]');
  const dialog = gallery.querySelector('[data-gallery-dialog]');
  const controller = new AbortController();
  const listen = (target,event,callback,options={}) => target.addEventListener(event,callback,{...options,signal:controller.signal});
  let index = 0, timer;
  const update = () => {
   index = Math.max(0,Math.min(panels.length-1,Math.round(track.scrollLeft / Math.max(track.clientWidth,1))));
   panels.forEach((panel,i) => {
    panel.inert = i !== index; panel.setAttribute('aria-hidden',String(i !== index));
    if (i !== index) {
     panel.querySelectorAll('video').forEach(video => video.pause());
     panel.querySelectorAll('iframe').forEach(frame => { try { const origin = new URL(frame.src).origin; frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),origin); frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}),origin); } catch {} });
     panel.querySelector('model-viewer')?.pause?.();
    }
   });
   thumbs.forEach((thumb,i) => thumb.setAttribute('aria-current',String(i === index)));
   count.textContent = count.dataset.format.replace('[current]',String(index+1)).replace('[total]',String(panels.length));
   previous.disabled = index === 0; next.disabled = index === panels.length-1;
   zoom.hidden = panels[index]?.dataset.mediaType !== 'image';
  };
  const show = i => { track.scrollTo({left:Math.max(0,Math.min(panels.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}); };
  thumbs.forEach((thumb,i) => listen(thumb,'click',event => { event.preventDefault(); show(i); }));
  listen(previous,'click',() => show(index-1)); listen(next,'click',() => show(index+1));
  listen(track,'scroll',() => { clearTimeout(timer); timer=setTimeout(update,80); },{passive:true});
  listen(track,'keydown',event => { if (event.target !== track) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index+(event.key === 'ArrowRight'?1:-1)); } });
  listen(zoom,'click',() => { const image=panels[index]?.querySelector('img'); if (!image) return; const clone=image.cloneNode(true); clone.removeAttribute('srcset'); clone.removeAttribute('sizes'); clone.loading='eager'; gallery.querySelector('[data-gallery-enlarged]').replaceChildren(clone); dialog.showModal(); document.body.classList.add('modal-open'); });
  listen(gallery.querySelector('[data-gallery-close]'),'click',() => dialog.close());
  listen(dialog,'close',() => { document.body.classList.remove('modal-open'); zoom.focus(); });
  listen(dialog,'click',event => { if(event.target === dialog) { const rect=dialog.getBoundingClientRect(); if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) dialog.close(); } });
  const resize=new ResizeObserver(() => { track.scrollTo({left:index*track.clientWidth,behavior:'instant'}); update(); });resize.observe(track);
  toolbar.hidden=false; update();
  dupontOwn(gallery,() => { clearTimeout(timer);resize.disconnect();controller.abort();if(dialog.open)dialog.close();document.body.classList.remove('modal-open'); });
 });
});
  } catch(e) { console.error(e); }
})();

})();
